/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";


// Target industries data
const targetIndustries = [
  { value: "technology", label: "Technology" },
  { value: "finance", label: "Finance" },
  { value: "healthcare", label: "Healthcare" },
  { value: "education", label: "Education" },
  { value: "retail", label: "Retail" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "construction", label: "Construction" },
  { value: "hospitality", label: "Hospitality" },
  { value: "automotive", label: "Automotive" },
  { value: "energy", label: "Energy" },
  { value: "real_estate", label: "Real Estate" },
  { value: "media", label: "Media & Entertainment" },
  { value: "consulting", label: "Consulting" },
  { value: "legal", label: "Legal Services" },
  { value: "marketing", label: "Marketing & Advertising" }
];

const companySizeOptions = [
  { value: "small", label: "Small (1-50 employees)" },
  { value: "medium", label: "Medium (51-250 employees)" },
  { value: "large", label: "Large (250+ employees)" }
];

const offerItemOptions = [
  { value: "product", label: "Product" },
  { value: "service", label: "Service" },
  { value: "join_event", label: "Join Event" },
  { value: "join_group", label: "Join Group" },
  { value: "join_course", label: "Join Course" },
  { value: "apply_to_job", label: "Apply to Job" }
];

const priorityOptions = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" }
];

const SaveGoalPopup = ({
  selectedGoalId = null,
  setSelectedGoalId = () => {},
  afterPopupClose = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const { t } = useTranslation();
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // Goal states
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [targetIndustry, setTargetIndustry] = useState([]);
  const [targetIndustryValue, setTargetIndustryValue] = useState([]);
  const [companySize, setCompanySize] = useState("");
  const [companySizeValue, setCompanySizeValue] = useState(null);
  
  // Budget range states
  const [budgetMin, setBudgetMin] = useState("");
  const [budgetMax, setBudgetMax] = useState("");
  const [budgetCurrency, setBudgetCurrency] = useState("USD");
  
  // Offer and priority states
  const [offerItem, setOfferItem] = useState("");
  const [offerItemValue, setOfferItemValue] = useState(null);
  const [priority, setPriority] = useState("");
  const [priorityValue, setPriorityValue] = useState(null);
  
  // Available actions states
  const [availableActions, setAvailableActions] = useState({
    sendmail: false,
    call: false,
    addtag: false,
    createtask: false
  });

  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const offcanvasBodyRef = useRef(null);

  // Add component states
  const [selectedComponent, setSelectedComponent] = useState("");
  const [selectedComponentValue, setSelectedComponentValue] = useState(null);
  const [componentOptions, setComponentOptions] = useState([]);

  const validateForm = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = t("Goal name is required.");
    }
    if (!description.trim()) {
      newErrors.description = t("Description is required.");
    }
    if (targetIndustry.length === 0) {
      newErrors.targetIndustry = t("Please select at least one target industry.");
    }
   
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      if (offcanvasBodyRef.current) {
        offcanvasBodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
    return Object.keys(newErrors).length === 0;
  };

  // Selection handlers
  const targetIndustrySelectionHandler = (val) => {
    if (val) {
      setTargetIndustryValue(val);
      setTargetIndustry(val.map(item => item.value));
    } else {
      setTargetIndustryValue([]);
      setTargetIndustry([]);
    }
  };

  const companySizeSelectionHandler = (val) => {
    if (val) {
      setCompanySizeValue(val);
      setCompanySize(val.value);
    } else {
      setCompanySizeValue(null);
      setCompanySize("");
    }
  };

  const offerItemSelectionHandler = (val) => {

    console.log("offer item selected--->", val);

    if (val) {
      setOfferItemValue(val.value);
      setOfferItem(val);
      // Reset component selection when offer item changes
      setSelectedComponent("");
      setSelectedComponentValue(null);
      // Get components for the selected offer item
      getComponentsByOfferItem(val.value);
    } else {
      setOfferItemValue(null);
      setOfferItem("");
      setSelectedComponent("");
      setSelectedComponentValue(null);
      setComponentOptions([]);
    }
  };

  const offerComponentSelectionHandler = (val) => {
    if (val) {
      setSelectedComponentValue(val.value);
      setSelectedComponent(val);
    } else {
      setSelectedComponentValue(null);
      setSelectedComponent("");
    }
  };

  const prioritySelectionHandler = (val) => {
    if (val) {
      setPriorityValue(val);
      setPriority(val.value);
    } else {
      setPriorityValue(null);
      setPriority("");
    }
  };

  const handleActionChange = (actionKey) => {
    setAvailableActions(prev => ({
      ...prev,
      [actionKey]: !prev[actionKey]
    }));
  };

  //function for upload doc files
  const docFileUploadHandler = async (docFiles) => {
    try {
      setDocFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD;

      const response = await uploadMultipleFile(requestUrl, docFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedDocFiles.length == 0) {
          setUploadedDocFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedDocFiles.concat(uploadedFileValues);
          setUploadedDocFiles(fileArr);
        }

        /*----- assign uploaded files with path for display end ------*/
        setDocFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedDocFileIds.length == 0) {
          setUploadedDocFileIds(fileIds);
        } else {
          let fileArr = uploadedDocFileIds.concat(fileIds);
          setUploadedDocFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
  };

  //function for get goal details
  const getGoalDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_COMPANY_GOAL_DETAILS +
        `/${selectedGoalId}`;

      console.log('request url for goal details', requestUrl)

      const response = await getData(requestUrl);

      console.log("response in goal details----->", response);
      
      if (response.status && response.data) {
        const data = response.data;
        setName(data.name || "");
        setDescription(data.description || "");
        setTargetIndustry(data.targetindustry || []);
        setTargetIndustryValue(data.targetindustry?.map(industry => ({ value: industry, label: industry })) || []);
        setCompanySize(data.companysize || "");
        setCompanySizeValue(companySizeOptions.find(option => option.value === data.companysize) || null);
        setBudgetMin(data.budgetrange?.min || "");
        setBudgetMax(data.budgetrange?.max || "");
        setBudgetCurrency(data.budgetrange?.currency || "USD");
        setOfferItemValue(data.offeritem || "");
        setOfferItem(offerItemOptions.find(option => option.value === data.offeritem) || null);
        setPriority(data.priority || "");
        setPriorityValue(priorityOptions.find(option => option.value === data.priority) || null);
        setAvailableActions(data.availableactions || {
          sendmail: false,
          call: false,
          addtag: false,
          createtask: false
        });

        // get selected component details
        if (data.offeritem && data.component) {
          getComponentsByOfferItem(data.offeritem);
          setSelectedComponentValue(data.component);
        }

      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Function to get components based on offer item
  const getComponentsByOfferItem = async (offerType) => {
    try {
      let requestUrl = "";
      
      switch(offerType) {
        case "product":
          requestUrl = url.API_BASE_URL + url.API_GET_ALL_PRODUCTS + `?companyid=${params.id}`;
          break;
        case "service":
          requestUrl = url.API_BASE_URL + url.API_GET_ALL_PRODUCTS + `?companyid=${params.id}&service=1`;
          break;
        // case "join_event":
        //   requestUrl = url.API_BASE_URL + url.API_GET_ALL_EVENTS;
        //   break;
        // case "join_group":
        //   requestUrl = url.API_BASE_URL + url.API_GET_ALL_GROUPS;
        //   break;
        // case "join_course":
        //   requestUrl = url.API_BASE_URL + url.API_GET_ALL_COURSES;
        //   break;
        // case "apply_to_job":
        //   requestUrl = url.API_BASE_URL + url.API_GET_ALL_JOBS;
        //   break;
        default:
          setComponentOptions([]);
          return;
      }

      console.log('request url', requestUrl)

      const response = await getData(requestUrl);

      console.log('response of getData:', response)

      if (response.status) {
        const options = response.data.map(item => ({
          value: item._id,
          label: item.name || item.title,
        }));
        setComponentOptions(options);
      }

    } catch (error) {
      console.log(error.message);
      setComponentOptions([]);
    }
  };


  // if there is selectedComponentValue and setComponentOptions then set selectedComponent using useeffect
  useEffect(() => {
    if (selectedComponentValue && componentOptions.length > 0) {
      const selectedOption = componentOptions.find(option => option.value === selectedComponentValue);
      setSelectedComponent(selectedOption || null);
    }
  }, [selectedComponentValue, componentOptions]);

  const saveGoalHandler = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setIsSaving(true);

      const formData = {
        companyid: params.id,
        name,
        description,
        targetindustry: targetIndustry,
        companysize: companySize,
        budgetrange: {
          min: Number(budgetMin) || 0,
          max: Number(budgetMax) || 0,
          currency: budgetCurrency
        },
        offeritem: offerItemValue,
        component: selectedComponentValue,
        priority,
        availableactions: availableActions,
        documents: uploadedDocFileIds,
      };

      console.log('form data', formData); 

      let requestUrl = url.API_BASE_URL;
      let response = {};

      if (selectedGoalId) {
        requestUrl +=
          url.API_UPDATE_COMPANY_GOAL +
          `/${selectedGoalId}` +
          ``;

        response = await putData(requestUrl, formData);

        console.log('response of goal save', response);

      } else {
        requestUrl += url.API_ADD_COMPANY_GOAL;
        response = await postData(requestUrl, formData);

        console.log('response of goal add', response);
      }

      setIsSaving(false);

      console.log("response in save goal----->", response);

      if (response.status) {
        // close the popup
        let offCanvasPopup = document.querySelector("#saveGoal");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        afterPopupClose(response.data);
        resetHandler();
      }
    } catch (error) {
      console.log(error.message);
      setIsSaving(false);
    }
  };

  // Reset handler for form fields
  const resetHandler = () => {
    setName("");
    setDescription("");
    setTargetIndustry([]);
    setTargetIndustryValue([]);
    setCompanySize("");
    setCompanySizeValue(null);
    setBudgetMin("");
    setBudgetMax("");
    setBudgetCurrency("USD");
    setOfferItem("");
    setOfferItemValue(null);
    setPriority("");
    setPriorityValue(null);
    setAvailableActions({
      sendmail:false,
      call:false,
      addtag: false,
      createtask: false,
    });
    setUploadedDocFiles([]);
    setUploadedDocFileIds([]);
    setSelectedGoalId(null);
    setErrors({});
    setSelectedComponent("");
    setSelectedComponentValue(null);
    setComponentOptions([]);
  };

  const customStyles = (hasError) => ({
    control: (base, state) => ({
      ...base,
      borderColor: hasError ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: hasError ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  });

  useEffect(() => {
    if (selectedGoalId) {
      getGoalDetails();
    }
  }, [selectedGoalId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveGoal"
      aria-labelledby="saveGoal"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              flag
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Create / Edit Goal
            </h3>
            <p className="text-white fs-sm mb-0">
              Manage company goal details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>

      <div className="offcanvas-body p-4" ref={offcanvasBodyRef}>
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Name, Description and Priority */}
              <div className="d-flex gap-3 mb-4">
                <div className="form-group p-3 border rounded-8 shadow-sm bg-white w-100">
                  <label
                    htmlFor="goalName"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Goal Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="goalName"
                    className={`form-control fs-sm shadow-none ${
                      errors.name ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      if (errors.name) {
                        setErrors((prev) => ({ ...prev, name: "" }));
                      }
                    }}
                    placeholder="Enter goal name..."
                  />
                  {errors.name && (
                    <div className="invalid-feedback d-block">
                      {errors.name}
                    </div>
                  )}
                
                  <label
                    htmlFor="description"
                    className="d-block fs-sm fw-semibold mb-2 text-dark mt-3"
                  >
                    Description the pain point this goal can solve<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="description"
                    className={`form-control fs-sm shadow-none ${
                      errors.description ? "is-invalid" : "border border-gray-300"
                    }`}
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      if (errors.description) {
                        setErrors((prev) => ({ ...prev, description: "" }));
                      }
                    }}
                    placeholder="Describe your goal..."
                    rows="3"
                  ></textarea>
                  {errors.description && (
                    <div className="invalid-feedback d-block">
                      {errors.description}
                    </div>
                  )}
                
                  <label
                    htmlFor="priority"
                    className="d-block fs-sm fw-semibold mb-2 text-dark"
                  >
                    Priority <span className="text-danger">*</span>
                  </label>
                  <Select
                    isClearable
                    options={priorityOptions}
                    value={priorityValue}
                    onChange={(val) => {
                      prioritySelectionHandler(val);
                      if (errors.priority) {
                        setErrors((prev) => ({ ...prev, priority: "" }));
                      }
                    }}
                    styles={customStyles(errors.priority)}
                    placeholder="Select priority..."
                    id="priority"
                  />
                  {errors.priority && (
                    <div className="invalid-feedback d-block">
                      {errors.priority}
                    </div>
                  )}
                </div>
              </div>

              {/* Target Industry and Company Size */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">Target Industry</h5>
                <div className="d-flex gap-3">
                  <div className="form-group w-50">
                    <label
                      htmlFor="targetIndustry"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Select Industry <span className="text-danger">*</span>
                    </label>
                    <Select
                      isMulti
                      isClearable
                      options={targetIndustries}
                      value={targetIndustryValue}
                      onChange={(val) => {
                        targetIndustrySelectionHandler(val);
                        if (errors.targetIndustry) {
                          setErrors((prev) => ({ ...prev, targetIndustry: "" }));
                        }
                      }}
                      styles={customStyles(errors.targetIndustry)}
                      placeholder="Select target industries..."
                      id="targetIndustry"
                    />
                    {errors.targetIndustry && (
                      <div className="invalid-feedback d-block">
                        {errors.targetIndustry}
                      </div>
                    )}
                  </div>

                  <div className="form-group w-50">
                    <label
                      htmlFor="companySize"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Company Size 
                    </label>
                    <Select
                      isClearable
                      options={companySizeOptions}
                      value={companySizeValue}
                      onChange={(val) => {
                        companySizeSelectionHandler(val);
                        if (errors.companySize) {
                          setErrors((prev) => ({ ...prev, companySize: "" }));
                        }
                      }}
                      styles={customStyles(errors.companySize)}
                      placeholder="Select company size..."
                      id="companySize"
                    />
                   
                  </div>
                </div>
              </div>

              {/* Budget Range */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">Budget Range</h5>
                <div className="d-flex gap-3">
                  <div className="form-group w-25">
                    <label
                      htmlFor="budgetMin"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Minimum Budget
                    </label>
                    <input
                      type="number"
                      id="budgetMin"
                      className={`form-control fs-sm shadow-none ${
                        errors.budgetRange ? "is-invalid" : "border border-gray-300"
                      }`}
                      value={budgetMin}
                      onChange={(e) => {
                        setBudgetMin(e.target.value);
                        if (errors.budgetRange) {
                          setErrors((prev) => ({ ...prev, budgetRange: "" }));
                        }
                      }}
                      placeholder="0"
                      min="0"
                    />
                  </div>
                  <div className="form-group w-25">
                    <label
                      htmlFor="budgetMax"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Maximum Budget
                    </label>
                    <input
                      type="number"
                      id="budgetMax"
                      className={`form-control fs-sm shadow-none ${
                        errors.budgetRange ? "is-invalid" : "border border-gray-300"
                      }`}
                      value={budgetMax}
                      onChange={(e) => {
                        setBudgetMax(e.target.value);
                        if (errors.budgetRange) {
                          setErrors((prev) => ({ ...prev, budgetRange: "" }));
                        }
                      }}
                      placeholder="0"
                      min="0"
                    />
                  </div>
                  <div className="form-group w-25">
                    <label
                      htmlFor="budgetCurrency"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Currency
                    </label>
                    <select
                      id="budgetCurrency"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={budgetCurrency}
                      onChange={(e) => setBudgetCurrency(e.target.value)}
                    >
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                      <option value="GBP">GBP</option>
                      <option value="JPY">JPY</option>
                    </select>
                  </div>
                </div>
                {errors.budgetRange && (
                  <div className="invalid-feedback d-block">
                    {errors.budgetRange}
                  </div>
                )}
              </div>

              {/* Offer Block */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">Offer</h5>
                <div className="d-flex gap-3 mb-3">
                  <div className="form-group w-50">
                    <label
                      htmlFor="offerItem"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Offer Item <span className="text-danger">*</span>
                    </label>
                    <Select
                      isClearable
                      options={offerItemOptions}
                      value={offerItem}
                      onChange={(val) => {
                        offerItemSelectionHandler(val);
                        if (errors.offerItem) {
                          setErrors((prev) => ({ ...prev, offerItem: "" }));
                        }
                      }}
                      styles={customStyles(errors.offerItem)}
                      placeholder="Select offer item..."
                      id="offerItem"
                    />
                    {errors.offerItem && (
                      <div className="invalid-feedback d-block">
                        {errors.offerItem}
                      </div>
                    )}
                  </div>

                  {offerItem && (
                    <div className="form-group w-50">
                      <label
                        htmlFor="component"
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                      >
                        Select {offerItem?.label || 'Component'}
                      </label>
                      <Select
                        isClearable
                        options={componentOptions}
                        value={selectedComponent}
                        onChange={offerComponentSelectionHandler}
                        styles={customStyles()}
                        placeholder={`Select ${offerItem?.label?.toLowerCase() || 'component'}...`}
                        id="component"
                        isLoading={componentOptions.length === 0 && offerItem}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Available Actions */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <h5 className="text-primary fw-semibold mb-3">Available Actions</h5>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                    <input
                      type="checkbox"
                      id="sendMail"
                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                      checked={availableActions.sendmail}
                      onChange={() => handleActionChange('sendmail')}
                    />
                    <label
                      htmlFor="sendMail"
                      className="form-check-label fw-semibold text-dark"
                    >
                      Send Mail
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                    <input
                      type="checkbox"
                      id="scheduleCall"
                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                      checked={availableActions.call}
                      onChange={() => handleActionChange('call')}
                    />
                    <label
                      htmlFor="scheduleCall"
                      className="form-check-label fw-semibold text-dark"
                    >
                      Schedule Call
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                    <input
                      type="checkbox"
                      id="addTag"
                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                      checked={availableActions.addtag}
                      onChange={() => handleActionChange('addtag')}
                    />
                    <label
                      htmlFor="addTag"
                      className="form-check-label fw-semibold text-dark"
                    >
                      Assign Tag
                    </label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                    <input
                      type="checkbox"
                      id="createTask"
                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                      checked={availableActions.createtask}
                      onChange={() => handleActionChange('createtask')}
                    />
                    <label
                      htmlFor="createTask"
                      className="form-check-label fw-semibold text-dark"
                    >
                      Create Task
                    </label>
                  </div>
                </div>
              </div>

       
            </div>

            {/* Actions */}
            <div className="action d-flex justify-content-end gap-3 pt-3 border-top mt-auto">
              <button
                onClick={saveGoalHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    Save Goal
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};



export default SaveGoalPopup;
